class VizouHeroSlider {
  constructor(root) {
    this.root = root;
    this.slides = [...root.querySelectorAll('[data-vizou-slide]')];
    this.dots = [...root.querySelectorAll('[data-vizou-dot]')];
    this.index = Math.max(0, this.slides.findIndex((slide) => slide.classList.contains('is-active')));
    this.timer = null;
    this.autoplay = root.dataset.autoplay === 'true';
    this.speed = Number(root.dataset.speed) || 5000;
    if (this.slides.length < 2) return;
    root.querySelector('[data-vizou-prev]')?.addEventListener('click', () => this.go(this.index - 1, true));
    root.querySelector('[data-vizou-next]')?.addEventListener('click', () => this.go(this.index + 1, true));
    this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.go(i, true)));
    root.addEventListener('mouseenter', () => this.stop());
    root.addEventListener('mouseleave', () => this.start());
    root.addEventListener('focusin', () => this.stop());
    root.addEventListener('focusout', () => this.start());
    this.start();
  }
  go(next, userAction = false) {
    const total = this.slides.length;
    this.index = (next + total) % total;
    this.slides.forEach((slide, i) => {
      const active = i === this.index;
      slide.classList.toggle('is-active', active);
      slide.setAttribute('aria-hidden', String(!active));
      slide.querySelectorAll('a,button,input,select,textarea').forEach((el) => el.tabIndex = active ? 0 : -1);
    });
    this.dots.forEach((dot, i) => {
      const active = i === this.index;
      dot.classList.toggle('is-active', active);
      dot.setAttribute('aria-selected', String(active));
    });
    if (userAction) { this.stop(); this.start(); }
  }
  start() {
    if (!this.autoplay || this.slides.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    this.stop();
    this.timer = window.setInterval(() => this.go(this.index + 1), this.speed);
  }
  stop() { if (this.timer) window.clearInterval(this.timer); this.timer = null; }
}

document.querySelectorAll('[data-vizou-hero-slider]').forEach((root) => new VizouHeroSlider(root));

document.addEventListener('shopify:block:select', (event) => {
  const block = event.target.closest('[data-vizou-slide]');
  const root = event.target.closest('[data-vizou-hero-slider]');
  if (!block || !root) return;
  const slider = new VizouHeroSlider(root);
  const index = slider.slides.indexOf(block);
  if (index >= 0) slider.go(index);
});
